var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFindInList = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M16.192 17.008a1.87 1.87 0 0 1-1.378-.563 1.87 1.87 0 0 1-.564-1.378q0-.814.564-1.378a1.87 1.87 0 0 1 1.378-.564q.813 0 1.378.564.563.564.563 1.378a1.82 1.82 0 0 1-.388 1.135l1.673 1.673a.28.28 0 0 1 .082.209.28.28 0 0 1-.082.209.28.28 0 0 1-.21.082.28.28 0 0 1-.208-.082l-1.673-1.673a1.82 1.82 0 0 1-1.135.388m0-.597q.56 0 .952-.392t.392-.952-.392-.953a1.3 1.3 0 0 0-.952-.392q-.56 0-.953.393a1.3 1.3 0 0 0-.392.952q0 .56.393.952.39.392.952.392M9.825 10.5a.45.45 0 0 0 0 .9h4.35a.45.45 0 0 0 0-.9zm-.45 2.55a.45.45 0 0 1 .45-.45H12.9a.45.45 0 0 1 0 .9H9.825a.45.45 0 0 1-.45-.45m0 2.1a.45.45 0 0 1 .45-.45H12.9a.45.45 0 0 1 0 .9H9.825a.45.45 0 0 1-.45-.45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M16.5 6.75h-2.895a1.576 1.576 0 0 0-3.06 0H7.5A1.5 1.5 0 0 0 6 8.25v8.25A1.5 1.5 0 0 0 7.5 18h5.4a.45.45 0 1 0 0-.9H7.5a.6.6 0 0 1-.6-.6V8.25a.6.6 0 0 1 .6-.6h1.125v.6c0 .414.336.75.75.75h5.25a.75.75 0 0 0 .75-.75v-.6H16.5a.6.6 0 0 1 .6.6v3.525a.45.45 0 0 0 .9 0V8.25a1.5 1.5 0 0 0-1.5-1.5m-4.425.9a.525.525 0 1 0 0-1.05.525.525 0 0 0 0 1.05",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFindInList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/find-in-list.0c0e678b.svg";